import React from 'react';
import Checkbox from 'src/shared/components/checkbox/Checkbox';
import type { ScopeDescriptor } from '../../state/api/engineApiTokensEngineSlice';

type ScopeCheckboxListProps = {
    scopes: ScopeDescriptor[];
    selected: Set<string>;
    onToggle: (scope: string) => void;
};

const ScopeCheckboxList = ({ scopes, selected, onToggle }: ScopeCheckboxListProps) => {
    return (
        <div className='flex flex-col gap-3'>
            {scopes.map(scope => (
                <label key={scope.name} className='flex items-start gap-3 cursor-pointer'>
                    <Checkbox checked={selected.has(scope.name)} onChange={() => onToggle(scope.name)} ariaLabel={scope.name} />
                    <span className='flex flex-col gap-0.5'>
                        <span className='text-sm font-medium text-primary'>{scope.name}</span>
                        <span className='text-xs text-grey-70'>{scope.description}</span>
                    </span>
                </label>
            ))}
        </div>
    );
};

export default ScopeCheckboxList;
